// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsRenterDocumentsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  AddIncomeDocumentsWebApiRequestDto,
  AddRequiredDocumentsWebApiRequestDto,
  AttachRequiredDocumentsWebApiRequestDto,
  DeleteDocumentWebApiRequestDto,
  DetachRequiredDocumentWebApiRequestDto,
  GetEditorUrlWebApiResponseDto,
  IncomeDocumentWebApiDto,
  RequestUserTokenWebApiResponseDto,
  RetrieveActiveDocumentsWebApiResponseDto,
  SetDocumentRedactionStatusWebApiRequestDto,
} from '../..';

interface GetEditorUrlParams {
  documentId: string;
}
interface RetrieveActiveDocumentsParams {
  documentIds: Array<string>;
}

export const CappsRenterDocumentsWebApiHandler_addIncomeDocuments_Path =
  '/api/web/renter/v1/documents/addIncomeDocuments';

export const CappsRenterDocumentsWebApiHandler_addIncomeDocuments = (
  postData: AddIncomeDocumentsWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, AddIncomeDocumentsWebApiRequestDto, Array<IncomeDocumentWebApiDto>>(
    {
      endpoint: CappsRenterDocumentsWebApiHandler_addIncomeDocuments_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};

export const CappsRenterDocumentsWebApiHandler_addRequiredDocuments_Path =
  '/api/web/renter/v1/documents/addRequiredDocuments';

export const CappsRenterDocumentsWebApiHandler_addRequiredDocuments = (
  postData: AddRequiredDocumentsWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, AddRequiredDocumentsWebApiRequestDto, Array<IncomeDocumentWebApiDto>>(
    {
      endpoint: CappsRenterDocumentsWebApiHandler_addRequiredDocuments_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};

export const CappsRenterDocumentsWebApiHandler_attachRequiredDocuments_Path =
  '/api/web/renter/v1/documents/attachRequiredDocuments';

export const CappsRenterDocumentsWebApiHandler_attachRequiredDocuments = (
  postData: AttachRequiredDocumentsWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, AttachRequiredDocumentsWebApiRequestDto, Array<IncomeDocumentWebApiDto>>(
    {
      endpoint: CappsRenterDocumentsWebApiHandler_attachRequiredDocuments_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};

export const CappsRenterDocumentsWebApiHandler_deleteDocument_Path = '/api/web/renter/v1/documents/deleteDocument';

export const CappsRenterDocumentsWebApiHandler_deleteDocument = (
  postData: DeleteDocumentWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, DeleteDocumentWebApiRequestDto, void>(
    {
      endpoint: CappsRenterDocumentsWebApiHandler_deleteDocument_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};

export const CappsRenterDocumentsWebApiHandler_detachRequiredDocument_Path =
  '/api/web/renter/v1/documents/detachRequiredDocument';

export const CappsRenterDocumentsWebApiHandler_detachRequiredDocument = (
  postData: DetachRequiredDocumentWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, DetachRequiredDocumentWebApiRequestDto, void>(
    {
      endpoint: CappsRenterDocumentsWebApiHandler_detachRequiredDocument_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};

export const CappsRenterDocumentsWebApiHandler_getEditorUrl_Path = '/api/web/renter/v1/documents/getEditorUrl';

export const CappsRenterDocumentsWebApiHandler_getEditorUrl = (getParams: GetEditorUrlParams, client = getClient()) => {
  return httpFrontEndRequest<GetEditorUrlParams, never, GetEditorUrlWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: CappsRenterDocumentsWebApiHandler_getEditorUrl_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsRenterDocumentsWebApiHandler_listActiveDocuments_Path =
  '/api/web/renter/v1/documents/listActiveDocuments';

export const CappsRenterDocumentsWebApiHandler_listActiveDocuments = (client = getClient()) => {
  return httpFrontEndRequest<never, never, RetrieveActiveDocumentsWebApiResponseDto>(
    {
      endpoint: CappsRenterDocumentsWebApiHandler_listActiveDocuments_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsRenterDocumentsWebApiHandler_requestUserToken_Path = '/api/web/renter/v1/documents/requestUserToken';

export const CappsRenterDocumentsWebApiHandler_requestUserToken = (client = getClient()) => {
  return httpFrontEndRequest<never, never, RequestUserTokenWebApiResponseDto>(
    {
      endpoint: CappsRenterDocumentsWebApiHandler_requestUserToken_Path,
      method: 'POST',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsRenterDocumentsWebApiHandler_retrieveActiveDocuments_Path =
  '/api/web/renter/v1/documents/retrieveActiveDocuments';

export const CappsRenterDocumentsWebApiHandler_retrieveActiveDocuments = (
  getParams: RetrieveActiveDocumentsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<RetrieveActiveDocumentsParams, never, RetrieveActiveDocumentsWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: CappsRenterDocumentsWebApiHandler_retrieveActiveDocuments_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsRenterDocumentsWebApiHandler_setDocumentRedactionStatus_Path =
  '/api/web/renter/v1/documents/setDocumentRedactionStatus';

export const CappsRenterDocumentsWebApiHandler_setDocumentRedactionStatus = (
  postData: SetDocumentRedactionStatusWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SetDocumentRedactionStatusWebApiRequestDto, void>(
    {
      endpoint: CappsRenterDocumentsWebApiHandler_setDocumentRedactionStatus_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};
